import React, { Component } from 'react';
import './App.css';
import GeneralStyles from './styles/GeneralStyles'
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import AppIndexPage from "./AppIndexPage";


class App extends Component {

    constructor(props) {
        super();

        this.state = {
            viewport: {
                width: document.documentElement.clientWidth,
                height: document.documentElement.clientHeight
            }
        };

        this.styler = new GeneralStyles();

        this.updateDimensions = this.updateDimensions.bind(this);
    }

    componentDidMount() {
        window.addEventListener("resize", this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }

    updateDimensions(event) {
        this.styler.setWidth(document.documentElement.clientHeight);
        this.setState({
            viewport: {
                width: document.documentElement.clientWidth,
                height: document.documentElement.clientHeight
            }
        });
    }

    render() {

        return (
            <Router>
                <AppIndexPage />
            </Router>
        );
  }
}

export default App;



// WEBPACK FOOTER //
// src/App.js